//약관
export const termsTitle1 = '두바키 파트너스 이용약관';
export const termsTitle2 = '개인정보 이용 및 제공 동의';